import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';

export default function StudentManagement() {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchStudents = async () => {
            try {
                const { data } = await api.get('/teacher/students/');
                setStudents(data);
            } catch (err) {
                setError('학생 목록을 불러오는 데 실패했습니다.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchStudents();
    }, []);

    const handleDelete = async (studentId) => {
        if (window.confirm('정말로 이 학생을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.')) {
            try {
                await api.delete(`/teacher/students/${studentId}/`);
                setStudents(students.filter(student => student.id !== studentId));
            } catch (err) {
                alert('학생 삭제에 실패했습니다.');
                console.error(err);
            }
        }
    };

    const handleChangePassword = async (studentId) => {
        const newPassword = window.prompt('새로운 비밀번호를 입력해주세요. (4자 이상)');
        if (newPassword) {
            if (newPassword.length < 4) {
                alert('비밀번호는 4자 이상이어야 합니다.');
                return;
            }
            try {
                await api.post(`/teacher/students/${studentId}/set-password/`, { password: newPassword });
                alert('비밀번호가 성공적으로 변경되었습니다.');
            } catch (err) {
                alert('비밀번호 변경에 실패했습니다.');
                console.error(err);
            }
        }
    };

    if (loading) return <Layout><p>로딩 중...</p></Layout>;
    if (error) return <Layout><p className="message error">{error}</p></Layout>;

    return (
        <Layout>
            <Link to="/teacher" className="back-link">선생님 홈으로</Link>
            <h1>학생 관리</h1>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>이름</th>
                            <th>아이디</th>
                            <th>작업</th>
                        </tr>
                    </thead>
                    <tbody>
                        {students.length === 0 ? (
                            <tr>
                                <td colSpan="3" style={{ textAlign: 'center' }}>등록된 학생이 없습니다.</td>
                            </tr>
                        ) : (
                            students.map((student) => (
                                <tr key={student.id}>
                                    <td>{student.first_name}</td>
                                    <td>{student.username}</td>
                                    <td>
                                        <button onClick={() => handleChangePassword(student.id)} className="change-password-button">
                                            비밀번호 변경
                                        </button>
                                        <button onClick={() => handleDelete(student.id)} className="table-delete-button">
                                            삭제
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </Layout>
    );
}
